var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayoutTopPanel5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,4 L20,4 C20.5522847,4 21,4.44771525 21,5 L21,7         C21,7.55228475 20.5522847,8 20,8 L3,8 C2.44771525,8 2,7.55228475 2,7         L2,5 C2,4.44771525 2.44771525,4 3,4 Z M10,10 L20,10 C20.5522847,10         21,10.4477153 21,11 L21,13 C21,13.5522847 20.5522847,14 20,14 L10,14         C9.44771525,14 9,13.5522847 9,13 L9,11 C9,10.4477153 9.44771525,10 10,10         Z M10,16 L20,16 C20.5522847,16 21,16.4477153 21,17 L21,19 C21,19.5522847         20.5522847,20 20,20 L10,20 C9.44771525,20 9,19.5522847 9,19 L9,17         C9,16.4477153 9.44771525,16 10,16 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    x: 2,
    y: 10,
    width: 5,
    height: 10,
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutTopPanel5);
export default __webpack_public_path__ + "static/media/Layout-top-panel-5.daf6e94c60e77b4231911794b5169d1c.svg";
export { ForwardRef as ReactComponent };